import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchChatBotResponseAPI,
  updateExerciseDetailsOnSessionId,
} from "../../api/chatBotApi";
import * as Endpoints from "../../entities/Endpoints";

export const fetchChatBotResponse = createAsyncThunk(
  `${Endpoints.GET_CHAT_BOT_DETAILS}`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await fetchChatBotResponseAPI(payload);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const postExerciseDetailsOnSessionId = createAsyncThunk(
  `${Endpoints.UPDATE_EXERCISE_DETAILS_ON_SESSION_ID}`,
  async (apiPayload, { rejectWithValue }) => {
    try {
      const response = await updateExerciseDetailsOnSessionId(apiPayload);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const chatBotSlice = createSlice({
  name: "chatBot",
  initialState: {
    chatResponse: null,
    exerciseUpdateResponse: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearChatResponse: (state) => {
      state.chatResponse = null;
      state.error = null;
    },
    clearExerciseUpdateResponse: (state) => {
      state.exerciseUpdateResponse = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatBotResponse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChatBotResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.chatResponse = action.payload;
      })
      .addCase(fetchChatBotResponse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(postExerciseDetailsOnSessionId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postExerciseDetailsOnSessionId.fulfilled, (state, action) => {
        state.loading = false;
        state.exerciseUpdateResponse = action.payload?.result?.message;
      })
      .addCase(postExerciseDetailsOnSessionId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearChatResponse, clearExerciseUpdateResponse } =
  chatBotSlice.actions;
export default chatBotSlice.reducer;
